export const initializeCookies = () => {
    const cookies = [
        "__hstc",
        "hubspotutk",
        "__hssrc",
        "__hssc"
    ];

    const cookieOptions = {
        path: '/',            // Chemin du cookie
        domain: '.vatel-light-brochure-form.vercel.app',  // Domaine principal
        secure: true,         // Cookie uniquement sur HTTPS
        sameSite: 'None',    // Permet l'utilisation cross-site
        maxAge: 31536000     // Durée de vie en secondes (1 an)
    };

    cookies.forEach(cookieName => {
        const cookieString = Object.entries(cookieOptions)
            .reduce((acc, [key, value]) => {
                // Convertit camelCase en kebab-case pour max-age
                const cookieKey = key === 'maxAge' ? 'max-age' : key;
                return `${acc}; ${cookieKey}=${value}`;
            }, `${cookieName}=value`);

        document.cookie = cookieString;
    });
};